import * as React from 'react'

export function BikeZeroTolerancePolicyImage() {
  return (
    <svg width={295} height={208} viewBox="0 0 295 208" fill="none">
      <path
        d="M43.0668 128.154C47.4656 114.457 69.4714 90.5416 58.167 79.0716C30.831 51.3308 43.5513 22.2066 85.4948 25.7835C93.0463 26.4273 100.259 29.0457 106.774 32.9247C138.159 51.6136 178.017 1.57446 206.628 29.8954C234.449 57.4345 211.016 98.3898 240.775 105.631C282.691 117.628 240.276 189.678 196.952 187.561C155.287 187.256 142.818 187.866 108.452 186.952C95.6792 186.039 29.0775 171.72 43.0668 128.154Z"
        fill="#E2F3F7"
      />
      <path
        d="M157.45 127.075C156.911 127.865 143.806 144.877 141.909 146.775C139.964 148.719 140.23 149.548 134.685 151.298C134.104 151.482 130.109 138.198 129.661 136.734C129.214 135.269 147.819 106.353 147.819 106.353L157.682 117.327L157.45 127.075Z"
        fill="#B58B70"
      />
      <path
        d="M42.0054 187.585H64.059"
        stroke="#345848"
        strokeWidth="0.261561"
        strokeMiterlimit="10"
      />
      <path
        d="M152.342 164.359L147.198 187.67C147.198 187.67 210.421 187.488 205.605 187.706C207.064 182.891 208.378 177.929 208.378 177.929L204.343 159.378L152.342 164.359Z"
        fill="#004D53"
      />
      <path
        d="M138.066 63.1517C138.066 63.1517 140.717 87.7689 140.421 89.04C140.318 89.4835 139.186 89.6921 139.186 89.6921L136.314 62.1031C136.314 62.1031 123.442 61.5126 123.405 60.9138C123.382 60.5306 123.54 59.676 124.81 59.7426C126.079 59.8084 136.807 60.5063 137.562 61.0614C137.955 61.3504 138.066 63.1517 138.066 63.1517Z"
        fill="#E6E6D5"
      />
      <path
        d="M123.456 60.8563C123.58 60.7039 124.798 60.7544 124.798 60.7544C124.798 60.7544 135.848 61.1336 136.597 62.1108C137.286 63.0076 139.191 89.7171 139.191 89.7171L128.886 87.4661L126.8 86.9699L126.285 85.265L123.469 62.2937C123.469 62.2937 123.331 61.0081 123.456 60.8563Z"
        fill="white"
      />
      <path
        d="M125.112 62.2882C125.112 62.2882 124.611 63.5655 125.361 64.0076C126.027 64.4013 126.554 63.7179 126.35 62.7179C126.196 61.9659 125.453 62.0498 125.112 62.2882Z"
        fill="#666666"
      />
      <path
        d="M125.534 65.0305C125.534 65.0305 125.319 65.5759 125.641 65.7658C125.925 65.9335 126.151 65.6418 126.064 65.2142C125.998 64.8926 125.68 64.9286 125.534 65.0305Z"
        fill="#C7C6B6"
      />
      <path
        d="M123.014 93.8069C123.014 93.8069 125.28 140.769 126.808 144.589C129.143 150.427 131.769 152.761 134.104 152.761C136.439 152.761 140.918 149.372 143.219 145.952C144.172 144.538 142.325 136.35 140.699 130.133C134.797 107.568 131.478 94.6823 131.478 94.6823L123.014 93.8069Z"
        fill="#C79C7D"
      />
      <path
        d="M106.856 75.5825C106.856 75.5825 117.098 80.4463 117.406 81.4776C117.474 81.7077 109.839 84.7398 109.839 84.7398C109.839 84.7398 107.362 76.4363 106.856 75.5825Z"
        fill="white"
      />
      <path
        d="M67.9603 51.5321C66.3146 54.6699 67.4709 123.678 67.4709 123.678L111.249 124.474L110.544 51.451C110.544 51.451 69.606 48.3943 67.9603 51.5321Z"
        fill="white"
      />
      <path
        d="M75.2217 60.9226C73.8567 62.7724 72.7349 111.875 74.6985 112.734C76.6632 113.593 99.7606 114.357 101.012 112.912C102.264 111.466 101.908 61.3669 101.693 59.9949C101.563 59.1705 76.5866 59.0729 75.2217 60.9226Z"
        stroke="#5D7A6C"
        strokeWidth="0.206231"
        strokeMiterlimit="10"
      />
      <path
        d="M87.9887 108.837C84.2238 108.942 80.6577 105.583 80.8282 101.553C81.0302 96.8028 83.906 94.3415 87.6708 94.2359C91.4357 94.1316 95.1858 97.3037 95.2736 101.336C95.3606 105.367 91.7535 108.731 87.9887 108.837Z"
        stroke="#5D7A6C"
        strokeWidth="0.271621"
        strokeMiterlimit="10"
      />
      <path
        d="M84.522 100.24L88.5749 104.016L96.0045 92.3417"
        stroke="#FF0000"
        strokeWidth="0.271621"
        strokeMiterlimit="10"
      />
      <path
        d="M79.96 66.1026L96.0186 65.8843"
        stroke="#5D7A6C"
        strokeWidth="0.271621"
        strokeMiterlimit="10"
      />
      <path
        d="M82.1123 69.6744L93.5346 69.463"
        stroke="#5D7A6C"
        strokeWidth="0.271621"
        strokeMiterlimit="10"
      />
      <path
        d="M81.1743 88.2976L99.0024 88.121"
        stroke="#D6D6D6"
        strokeWidth="0.271621"
        strokeMiterlimit="10"
      />
      <path
        d="M81.1167 85.0036L96.1167 85.0036"
        stroke="#D6D6D6"
        strokeWidth="0.271621"
        strokeMiterlimit="10"
      />
      <path
        d="M81.061 81.8077L91.061 81.8077"
        stroke="#D6D6D6"
        strokeWidth="0.271621"
        strokeMiterlimit="10"
      />
      <path
        d="M81.0037 78.5137L96.0037 78.5137"
        stroke="#D6D6D6"
        strokeWidth="0.271621"
        strokeMiterlimit="10"
      />
      <path
        d="M69.6055 187.494H236.838"
        stroke="#345848"
        strokeWidth="0.261561"
        strokeMiterlimit="10"
      />
      <path
        d="M200.498 166.705L168.101 171.741"
        stroke="#DEF4F8"
        strokeWidth="0.206231"
        strokeMiterlimit="10"
      />
      <path
        d="M132.062 96.7777C131.744 95.639 133.867 86.9758 134.689 84.2112C135.661 80.9366 136.606 79.6038 136.956 78.4312C137.528 76.517 137.28 75.6922 136.242 75.4982C135.204 75.3041 134.498 76.2301 134.184 76.9321C133.615 78.2053 132.32 80.7099 132.008 80.6282C131.852 80.5873 134.322 75.1503 134.698 74.2216C135.074 73.2929 135.561 72.552 135.736 71.728C135.909 70.9046 135.625 70.197 135.055 70.1263C134.485 70.055 133.97 70.0778 133.281 70.924C133.502 69.9545 133.924 68.8795 134.006 68.348C134.089 67.8171 133.749 67.0159 133.078 66.9972C132.407 66.9785 131.553 67.544 131.167 68.2329C130.782 68.9225 129.473 71.1978 129 72.1681C128.523 73.1494 127.393 74.591 127.393 74.591C127.393 74.591 129.21 69.6156 129.486 68.7395C129.761 67.8628 129.577 67.1032 128.851 66.991C128.125 66.8787 126.957 67.2862 126.296 68.8511C125.635 70.4167 122.568 78.7937 122.055 81.8057C121.374 85.8108 121.738 92.6131 123.461 97.2503C131.166 100.208 132.062 96.7777 132.062 96.7777Z"
        fill="#C79C7D"
      />
      <path
        d="M140.085 110.312C139.866 112.428 152.78 122.716 152.78 122.716L157.45 88.4954C157.45 88.4954 140.303 108.195 140.085 110.312Z"
        fill="#FF0000"
      />
      <path
        d="M170.834 71.3266C170.834 71.3266 170.389 79.1212 169.595 84.0886C173.97 90.9805 188.156 80.6868 188.156 80.6868L186.11 62.6719L170.834 71.3266Z"
        fill="#C79C7D"
      />
      <path
        d="M187.068 54.0605C187.068 54.0605 187.278 60.9502 187.357 63.7931C187.398 65.2298 183.97 62.1672 184.659 59.8725C185.348 57.5778 187.068 54.0605 187.068 54.0605Z"
        fill="#24372B"
      />
      <path
        d="M167.09 49.3117C167.09 49.3117 168.993 58.4476 167.74 65.6726C167.336 68.011 170.336 77.074 170.336 77.074C170.336 77.074 173.501 79.5053 176.288 78.7304C183.856 75.6595 186.647 69.9682 186.647 69.9682C186.647 69.9682 188.096 65.1355 188.311 63.8083C188.99 59.6133 188.192 52.4644 187.184 51.9412C185.568 51.1026 184.842 43.8033 184.842 43.8033C184.842 43.8033 178.289 49.4455 177.302 49.0608C176.315 48.6748 167.302 43.9004 166.961 44.9025C165.577 48.9694 167.09 49.3117 167.09 49.3117Z"
        fill="#D1A683"
      />
      <path
        d="M167.862 65.3543C167.862 65.3543 167.594 68.0337 167.21 69.8224C166.878 71.3714 166.474 74.5795 168.019 76.7696C169.781 79.2632 172.139 80.3582 175.708 79.7379C179.263 79.1197 184.489 75.4064 186.472 72.6806C188.455 69.9562 188.141 66.3606 188.702 65.0424C189.583 62.9716 191.366 52.5717 191.36 50.4551C191.354 47.5394 189.942 38.8818 181.953 38.4978C180 38.4036 175.659 39.4147 172.979 41.7573C170.244 44.1469 167.981 41.41 165.693 43.5128C164.065 45.0104 163.715 47.7258 163.852 50.7212C164.001 53.9217 167.979 55.574 167.979 55.574C167.979 55.574 167.746 48.8167 172.017 50.9575C178.698 54.3071 180.776 48.6462 183.116 49.9616C186.309 51.7587 185.866 53.7304 185.7 58.3774C185.539 62.8787 185.487 68.8875 184.459 69.6908C183.431 70.494 180.511 70.2445 178.163 68.1023C176.544 66.624 175.492 65.8291 173.324 66.0883C171.135 66.3495 171.062 67.6296 169.826 67.9006C169.185 68.0406 168.709 67.6421 168.452 67.1493C168.212 66.6912 167.862 65.3543 167.862 65.3543Z"
        fill="#24372B"
      />
      <path
        d="M188.957 65.1006C188.957 65.1006 189.41 65.337 189.984 65.2198C190.559 65.1027 191.253 64.6321 191.737 63.2162C192.308 61.5466 191.869 57.9379 191.869 57.9379C191.869 57.9379 191.006 56.1949 190.258 56.1672C188.435 56.0986 187.491 61.8793 187.265 62.9217C187.039 63.964 188.957 65.1006 188.957 65.1006Z"
        fill="#D1A683"
      />
      <path
        d="M165.391 57.0119C164.921 57.7992 164.91 59.4542 165.465 60.4786C166.021 61.5022 167.012 62.7358 167.882 63.1524C168.753 63.5696 170.188 63.9182 171.094 63.4393C173.072 62.3962 174.142 58.2289 173.618 57.4347C172.884 56.3182 171.579 55.7734 169.779 55.7422C167.979 55.7118 166.316 55.4588 165.391 57.0119Z"
        stroke="#FF0000"
        strokeWidth="0.266591"
        strokeMiterlimit="10"
      />
      <path
        d="M184.631 58.4416C184.954 59.2941 184.291 60.8375 183.563 61.7558C182.835 62.6741 181.642 63.7261 180.71 63.995C179.78 64.2626 178.197 64.2286 177.512 63.4725C175.763 61.5423 175.411 58.1173 176.066 57.42C176.987 56.4401 178.353 56.2661 180.148 56.3818C182.144 56.5108 183.993 56.7596 184.631 58.4416Z"
        stroke="#FF0000"
        strokeWidth="0.266591"
        strokeMiterlimit="10"
      />
      <path
        d="M171.866 56.6254L177.164 57.1784"
        stroke="#FF0000"
        strokeWidth="0.266591"
        strokeMiterlimit="10"
      />
      <path
        d="M166.669 44.0933C166.669 44.0933 170.081 47.4989 173.089 44.5437C175.421 42.2518 179.072 39.375 182.445 40.6266C185.817 41.8783 188.909 44.0163 189.129 51.1485"
        stroke="#345848"
        strokeWidth="0.266591"
        strokeMiterlimit="10"
      />
      <path
        d="M193.055 79.834C195.162 79.3073 206.374 84.2086 208.481 85.262C210.588 86.3161 219.017 112.654 219.017 112.654C219.017 112.654 201.588 119.519 202.16 121.084C202.977 123.32 206.188 162.721 206.188 162.721L165.584 167.828L151.685 165.201C151.685 165.201 153.098 97.1721 153.654 94.3902C153.8 92.6396 157.594 87.4957 161.097 86.0355C167.638 84.0533 193.819 79.5783 193.055 79.834Z"
        fill="#FF0000"
      />
      <path
        d="M188.047 80.4362L169.418 84.2297L169.88 84.7754C174.436 90.4023 188.058 80.5541 188.058 80.5541L188.047 80.4362Z"
        fill="#AF8B6F"
      />
      <path
        d="M209.003 144.415C209.003 144.415 201.997 119.865 201.069 112.864C200.87 111.368 218.535 110.039 218.535 110.039C218.535 110.039 224.834 134.406 225.892 142.249C227.241 152.254 209.003 144.415 209.003 144.415Z"
        fill="#C79C7D"
      />
      <path
        d="M155.992 93.8204C152.707 104.603 152.741 122.311 152.741 122.311"
        stroke="#34453A"
        strokeWidth="0.211261"
        strokeMiterlimit="10"
      />
      <path
        d="M172.261 89.017C172.261 89.017 174.621 89.9789 178.827 88.3607C184.519 86.172 189.115 82.4503 189.115 82.4503"
        stroke="#34453A"
        strokeWidth="0.211261"
        strokeMiterlimit="10"
      />
      <path
        d="M186.056 175.81C186.056 175.81 208.31 144.363 210.863 141.954C212.75 140.176 223.611 133.238 224.022 134.658C224.365 135.846 225.88 141.823 226.023 143.093C226.167 144.363 225.157 150.054 224.148 151.148C223.139 152.243 221.847 153.879 220.004 155.675C209.137 166.258 192.317 184.317 192.268 184.054C192.268 184.054 189.916 181.405 188.453 179.75C187.034 178.145 186.056 175.81 186.056 175.81Z"
        fill="#C79C7D"
      />
      <path
        d="M197.46 126.907C197.46 126.907 221.054 116.838 221.952 115.306C222.849 113.774 210.46 86.4119 208.49 85.4271C207.5 84.933 192.24 81.3249 192.269 81.352C192.299 81.3783 187.361 109.177 187.586 109.834C187.811 110.49 197.46 126.907 197.46 126.907Z"
        fill="#FF0000"
      />
      <path
        d="M193.059 97.6532C193.059 97.6532 192.815 111.224 197.461 126.911L202.252 124.722"
        stroke="#34453A"
        strokeWidth="0.211261"
        strokeMiterlimit="10"
      />
      <path
        d="M178.743 169.923C178.743 169.923 179.89 177.942 189.775 184.901"
        stroke="#DEF4F8"
        strokeWidth="0.206231"
        strokeMiterlimit="10"
      />
      <path
        d="M188.348 103.911C187.876 103.02 186.952 102.472 185.954 102.472H178.341C178.201 102.472 178.083 102.59 178.083 102.74C178.083 102.805 178.115 102.869 178.158 102.923L179.812 104.587C179.962 104.738 180.156 104.824 180.36 104.813H185.717C186.104 104.813 186.415 105.113 186.415 105.5C186.415 105.887 186.115 106.198 185.728 106.198H182.045C181.906 106.198 181.788 106.316 181.788 106.466C181.788 106.531 181.82 106.595 181.863 106.649L183.516 108.313C183.667 108.464 183.86 108.539 184.075 108.539H185.75C187.919 108.539 189.561 106.219 188.348 103.911Z"
        fill="white"
      />
    </svg>
  )
}
